"use strict";
$(window).scroll(() => {
  if (!$(".nav-bar").hasClass("no-scroll")) {
    if ($(".nav-bar").offset().top > 150) {
      $(".nav-bar").addClass("active");
    } else {
      $(".nav-bar").removeClass("active");
    }
  }
});

$(document).ready(() => {
  $("a.page-scroll").bind("click", function(event) {
    let anchor = $(this);
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $(anchor.attr("href")).offset().top
        },
        1500,
        "easeInOutExpo"
      );

    event.preventDefault();
  });

  const controller = new ScrollMagic.Controller();

  // AGB Page
  new ScrollMagic.Scene({
    triggerElement: "#agb-container",
    offset: 400,
    duration: $("#agb-container").height()
  })
    .setPin("#agb-nav")
    .addTo(controller);

  const items = [
    "vorbemerkung",
    "vermittlungsbedingungen",
    "nutzungsverhaeltnis",
    "reisebedingungen"
  ];

  for (let i = 0; i < items.length; i++) {
    let item = items[i];

    new ScrollMagic.Scene({
      triggerElement: `#${item}`,
      duration: $(`#${item}`).height()
    })
      .setClassToggle(`#nav-${item}`, "active")
      .addTo(controller);
  }

  const split = window.location.toString().split("/");

  $(".nav-bar select").val(split[split.length - 1]);
  $(".nav-bar select").on("change", function(e) {
    window.location = $(this).val();
  });

  const textParts = ["@kuk", ".de", "-reiseservice", "info"];

  $(".email-content").click(function() {
    $(this).removeClass("button-outline");
    $(this).html(textParts[3] + textParts[0] + textParts[2] + textParts[1]);
  });
});
